import { _delete, _get, _post, _put } from "../../http";

export const getQuickActions = () => _get(`/lia-api/quick-actions`);

export const createQuickAction = (body) => _post(`/lia-api/quick-actions`, body);

export const updateQuickAction = (id, body) => _put(`/lia-api/quick-actions/${id}`, body);

export const deleteQuickAction = (id) => _delete(`/lia-api/quick-actions/${id}`);

// Guarda el orden de las acciones de un rol. body: { rol, ids } con los ids en
// el orden final; cada rol tiene su propio orden dentro de NIA.
export const reorderQuickActions = (body) => _put(`/lia-api/quick-actions/orden`, body);
